/** Formatting helpers — ports of `money`, `shortDate`, `cn` (L80-82). */

export const money = (v: unknown): string => `${Number(v || 0).toLocaleString('ar-SA')} ر.س`;

export const shortDate = (v: string | number | Date | null | undefined): string =>
  v ? new Date(v).toLocaleDateString('ar-SA', { day: 'numeric', month: 'short', year: 'numeric' }) : '—';

export const cn = (...a: unknown[]): string => a.filter(Boolean).join(' ');

/** `uid()` (L83) — used client-side for transient keys only. */
export const uid = (): string => Date.now().toString(36) + Math.random().toString(36).slice(2, 6);

/** Arabic-locale number without currency (used by WhatsApp templates / prints). */
export const arNum = (v: unknown): string => Number(v || 0).toLocaleString('ar-SA');
